import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Events } from 'ionic-angular';
import { Observable } from 'rxjs';
import { ServerProvider } from './server';
import { SettingsProvider } from './settings';
import { ViewProvider } from './view';

@Injectable()
export class LoginProvider {

  private user: any;

  constructor(private storage: Storage, private events: Events,
    private serverProvider: ServerProvider, private settingsProvider: SettingsProvider, private viewProvider: ViewProvider) {

    events.subscribe('login:submit', (user, autoLogin) => this.login(user, autoLogin));
    events.subscribe('menu:logout', () => { this.logout(); });
  }

  public get() {
    return this.user;
  }

  public autoLogin(handleEvent = true) {
    if (!this.settingsProvider.get().autoLogin) {
      console.debug("Login automático desativado");
      return;
    }
    console.debug("Login automático ativado");

    this.load().subscribe(
      (user) => {
        if (!user) {
          console.debug("Usuário não encontrado");
          return;
        }
        console.debug("Usuário carregado: ", user);

        if (user && user.cpf && user.cpf != '' && user.password && user.password != '') {
          this.login(user, true, handleEvent);
        }
      },
      (error) => { console.error('Não foi possível carregar os dados do login. ' + error); }
    );
  }

  private login(user, autoLogin: boolean, handleEvent = true) {
    let body = {
      operacao: 'LOGAR',
      cpf: user.cpf,
      senha: user.password
    };

    this.serverProvider.postData(body).subscribe(
      (data) => {
        let _user = { name: data.nome, cpf: user.cpf, password: user.password, checked: data.validado };

        this.serverProvider.setToken(data.token);
        this.settingsProvider.setAutoLogin(autoLogin);
        this.save(_user, autoLogin);

        if (_user.checked) {
          if (handleEvent) {
            this.events.publish('app:login');
          }
        } else {
          this.events.publish('app:checkRegister', _user, data.dispNotificados);
        }
      },
      (error) => { console.error('Erro ao buscar os dados. ' + error); }
    );
  }

  private logout() {
    this.viewProvider.showConfirm('Deseja sair do aplicativo?', () => {
      this.user = { name: '', cpf: '', password: '' };

      this.clear();

      console.debug('Dados do usuário removidos.');

      this.events.publish('app:logout');
    });
  }

  public requestPasswordRecovery(cpf: string): Observable<Array<string>> {
    let body = {
      operacao: 'RECUPERAR_SENHA',
      cpf: cpf
    };

    return Observable.create((observer) => {
      this.serverProvider.postData(body).subscribe(
        (data) => {
          let message = data.mensagem.replace(new RegExp("Enviado para ", 'g'), "");
          let dispNotificados = message.split("<br>");
          dispNotificados = dispNotificados.filter((d) => d != undefined && d != '');

          observer.next(dispNotificados);
          observer.complete();
        },
        (error) => { observer.error(error) }
      );
    });
  }

  public sendRecoveryCode(cpf: string, code: string): Observable<string> {
    let body = {
      operacao: 'INFORMAR_CODIGO_SENHA',
      cpf: cpf,
      codigoVerificacao: code
    };

    return Observable.create((observer) => {
      this.serverProvider.postData(body).subscribe(
        (data) => {
          observer.next(data.tokenValidacao);
          observer.complete();
        },
        (error) => { observer.error(error) }
      );
    });
  }

  public changePassword(cpf: string, token: string, password: string): Observable<string> {
    let body = {
      operacao: 'CONFIRMAR_RECUPERACAO_SENHA',
      cpf: cpf,
      tokenValidacao: token,
      senha: password
    };

    return Observable.create((observer) => {
      this.serverProvider.postData(body).subscribe(
        (data) => {
          observer.next(data.mensagem);
          observer.complete();
        },
        (error) => { observer.error(error) }
      );
    });
  }

  /*####################################################
  ####################### STORAGE ######################
  ####################################################*/
  private load(): Observable<any> {
    return Observable.create((observer) => {
      this.storage.get('user')
        .then((user) => {
          observer.next(user);
          observer.complete();
        })
        .catch((error) => { observer.error(error); });
    });
  }

  private save(user, persistPassword) {
    this.user = { name: user.name, cpf: user.cpf };

    if (persistPassword) {
      this.user.password = user.password;
    }

    this.storage.set('user', this.user)
      .catch((error) => console.error(error));
  }

  private clear() {
    this.storage.remove('user');
    this.settingsProvider.setAutoLogin(false);
  }
}


// WEBPACK FOOTER //
// ./src/providers/login.ts